// extracted by mini-css-extract-plugin
export var actionText = "_mu-4";
export var container = "_mu-0";
export var leftSection = "_mu-1";
export var rightSection = "_mu-2";
export var settingsButton = "_mu-6";
export var settingsIcon = "_mu-7";
export var shortcut = "_mu-5";
export var shortcutGroup = "_mu-3";